import { render } from "./Checkbox.vue?vue&type=template&id=6237481c&scoped=true&ts=true"
import script from "./Checkbox.vue?vue&type=script&lang=ts"
export * from "./Checkbox.vue?vue&type=script&lang=ts"

import "./Checkbox.vue?vue&type=style&index=0&id=6237481c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6237481c"]])

export default __exports__